import {Route, Switch} from "react-router-dom";
import React from "react";
import PublisherTagPage from "./PublisherTag/publisherTag";
import PublisherTagsPage from "./PublisherTags/container"
import {urlService} from "../../routing/urlsService";
import {Server} from "@leap4/auth";
import {Grid} from "@leap4/frontend";
import {OneOrgOnly} from "../../shared/OneOrgOnly/OneOrgOnly";


function PublisherTagsModule() {
    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }
    return (
        <Grid direction="row" alignItems="center" container>
            <Switch>
                {/* WARNNING: Never warp <Route/> with another component (even Grid)*/}
                <Route exact path={urlService.publisherTags()} component={PublisherTagsPage}/>
                <Route exact path={urlService.publisherTag()} component={PublisherTagPage}/>
            </Switch>
        </Grid>
    )
}


export default PublisherTagsModule